import type { BigScreenQueue } from '../../lib/big-screen-queue';

/** The same six lanes and two batches as the big-screen column, in the public board's dark theme. */
export function PublicQueueCard({ queue }: { queue: BigScreenQueue }) {
  return (
    <section aria-label="Shooting queue" className="overflow-hidden rounded-[var(--radius-lg)] border border-[#4a3a2c] bg-[#1a1410] text-[#f3ece0]">
      <h2 className="border-b border-[#4a3a2c] bg-[#231b15] px-4 py-3 text-sm font-extrabold uppercase tracking-[0.18em]">
        Shooting queue
      </h2>
      <div className="border-b border-[#4a3a2c] bg-[rgba(224,27,34,0.08)] px-4 py-3">
        <h3 className="mb-2 text-xs font-extrabold uppercase tracking-[0.16em] text-[#e01b22]">Now shooting</h3>
        {queue.nowTeam ? <p className="mb-2 truncate text-xl font-bold">{queue.nowTeam}</p> : null}
        <ol className="space-y-1.5">
          {queue.now.map((lane) => (
            <li key={lane.lane} className="flex items-center gap-2 text-sm">
              <span className="inline-flex min-w-[4.5rem] justify-center rounded bg-[#e01b22] px-2 py-1 text-xs font-extrabold text-white">
                Lane {lane.lane}
              </span>
              <span className="w-20 shrink-0 tabular-nums text-[#a89f92]">{lane.bib}</span>
              <span className="min-w-0 truncate font-semibold">{lane.name}</span>
            </li>
          ))}
        </ol>
      </div>
      <div className="space-y-3 px-4 py-3">
        {queue.upcoming.map((batch, index) => (
          <div key={batch.label} className={`rounded-xl border px-3 py-2 ${index === 0 ? 'border-[#e01b22] bg-[#301b18]' : 'border-[#4a3a2c] bg-[#0f0c0a]'}`}>
            <h3 className="mb-1 text-xs font-extrabold uppercase tracking-[0.14em] text-[#a89f92]">
              {index === 0 ? 'Up next' : 'Following'}
            </h3>
            <p className={`truncate font-bold ${index === 0 ? 'text-xl' : 'text-base'}`}>{batch.label}</p>
            {batch.shooters.length === 0 ? (
              <p className="text-sm text-[#6e5e52]">Waiting for check-in</p>
            ) : (
              <ul className="grid grid-cols-2 gap-x-3 gap-y-1">
                {batch.shooters.map((shooter) => (
                  <li key={`${batch.label}-${shooter.bib}-${shooter.name}`} className="min-w-0 truncate text-sm">
                    <span className="mr-1 tabular-nums text-[#a89f92]">{shooter.bib}</span>
                    {shooter.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
